import React from 'react'

const PatentsAccordion = ({ data }) => {
  const { edges: patents } = data || {}

  return (
    patents?.map(({ node }) => (
      <tr key={node.id}>
        <td>{node.name}</td>
        <td>{node.code}</td>
      </tr>
    ))
  )
}

export default PatentsAccordion